import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { getYoutubeThumbnailUrl } from 'domain/adPreview/format'

// YouTube in-app chrome: logo header row, media, headline/description, an
// orange "Ad" tag, a blue "Learn more" button, a mock watch-next
// video-thumbnail row, and a YouTube-style bottom nav bar (Figma nodes
// 31512:16212, 31518:16515 — see googleDisplayVariations.js).
//
// When `ad.companionBanner` is present, it renders next to the CTA rather than
// in the media area (a companion banner is a static image shown alongside a
// YouTube video ad).
const YoutubeChromeCard = ({ ad }) => {
  const { headline, description, media, callToAction, companionBanner, businessName } = ad

  return (
    <div className="google-display-card google-display-card--youtube">
      <div className="google-display-card__yt-header">
        <span className="google-display-card__yt-logo">YouTube</span>
      </div>
      <div className="google-display-card__yt-media-wrap">
        {media?.youtube_video_id ? (
          // A real youtube_video_id item never has a `url` (see
          // mapYoutubeVideoForPayload) — render YouTube's own public
          // thumbnail instead of a sourceless <video> tag, same approach
          // YouTubeUrlInput.jsx's own preview card takes.
          <LazyLoadImage
            className="google-display-card__media"
            src={getYoutubeThumbnailUrl(media.youtube_video_id)}
            alt={media?.filename}
            visibleByDefault
          />
        ) : (
          // visibleByDefault: see BareGradientCard.jsx — avoids the lazy-load
          // placeholder's raw-pixel inline height inflating a horizontally-
          // scrolling row for any card not yet scrolled into view.
          <LazyLoadImage
            className="google-display-card__media"
            src={media?.url}
            alt={media?.filename}
            width={media?.width}
            height={media?.height}
            visibleByDefault
          />
        )}
        <span className="google-display-card__ad-tag">Ad</span>
      </div>
      <div className="google-display-card__yt-body">
        <div className="google-display-card__headline">{headline}</div>
        <div className="google-display-card__description">{description}</div>
        <button
          type="button"
          className="google-display-card__cta-pill google-display-card__cta-pill--blue"
        >
          {callToAction}
        </button>
        {companionBanner?.url && (
          <img
            className="google-display-card__yt-companion-banner"
            src={companionBanner.url}
            alt={businessName}
          />
        )}
      </div>
      <div className="google-display-card__yt-watch-next">
        <span className="google-display-card__yt-thumb" />
        <span className="google-display-card__yt-thumb" />
      </div>
      <div className="google-display-card__yt-nav">
        <span>Home</span>
        <span>Shorts</span>
        <span>Subscriptions</span>
        <span>Library</span>
      </div>
    </div>
  )
}

YoutubeChromeCard.propTypes = {
  ad: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    callToAction: PropTypes.string,
    media: PropTypes.object,
    companionBanner: PropTypes.object,
    businessName: PropTypes.string,
  }).isRequired,
}

export default YoutubeChromeCard
